export const VERIFICATIONS_FETCH = `VERIFICATIONS_FETCH`;
export const ORDER_OPTIONS_FETCH = `ORDER_OPTIONS_FETCH`;
export const PAYMENT_COLLECTIONS_FETCH = `PAYMENT_COLLECTIONS_FETCH`;
